import { CalculatorSettingsChoice, IApiError, ICalculatorPaymentSet, ICalculatorRules, IDaySegment, IPOSResults, ISite, ITipCalculatorChangeLogEntry, SettingsGateState } from 'types';
import { PosUnclosedChecksError, TipCalculationNoDataError, TipCalculationNoLaborForTicketsError, TipCalculationValidationError, TipCalculatorFriendlyError } from 'utils/tipCalculator';

export type ContentStatus = 'loading' | 'error' | 'validationError' | 'success';

export type ContentErrors = TipCalculationNoLaborForTicketsError | PosUnclosedChecksError | TipCalculationValidationError | TipCalculationNoDataError | TipCalculatorFriendlyError | IApiError[] | unknown;

export interface IContentProps {
  dataCy: string;
  businessDate: string;
  message: string;
  stepMessage: string;
  status: ContentStatus;
  buttonText: string;
  errors?: ContentErrors;
  timeZone?: string;
  mode: TipCalculatorProcessingModalMode;
  onClick?(skipNoLabor?: boolean): void;
  onSecondaryClick?(): void;
  onClose(): void;
}

interface IBaseProps {
  site: ISite;
  businessDate: string;
  tipCalcRules: ICalculatorRules;
  segments: IDaySegment[];
  onClose(): void;
}

export enum TipCalculatorProcessingModalMode {
  INITIAL = 'initial',
  RECALCULATE = 'recalculate',
}

export interface IInitialModeProps extends IBaseProps {
  mode: TipCalculatorProcessingModalMode.INITIAL;
  paymentSet: ICalculatorPaymentSet;
  dataCy?: string;
}

export interface IRecalculateModeProps extends IBaseProps {
  mode: TipCalculatorProcessingModalMode.RECALCULATE;
  posDataResults: IPOSResults;
  changeLogEntries?: ITipCalculatorChangeLogEntry[];
  dataCy?: string;
  onSuccess?: () => void;
}

export type ITipCalculatorProcessingModalProps = IInitialModeProps | IRecalculateModeProps;

export interface ISettingsGateWorkflowProps {
  state: SettingsGateState;
  onCancel(): void;
  onCalculate(choice?: CalculatorSettingsChoice): void;
}

/** What either workflow hook hands back. Only the initial workflow can raise the settings gate. */
export interface IWorkflowResult {
  contentProps: Partial<IContentProps>;
  timeZone?: string;
  settingsGate?: ISettingsGateWorkflowProps;
}
